<template lang="pug">
    v-dialog.modal(v-model="showMe" width="600" @keydown.escape="showMe = false" @keydown.enter="handle($event)")
        v-toolbar.title.font-weight-bold(:color="color" dark)
            |   Requiere Autorización del Supervisor
        v-card
            v-container     
                v-layout(row wrap)
                    v-flex(xs12).mb-4
                        slot(name="content")
                    v-flex(xs12).mb-4.input-container
                        span SUPERVISOR
                        v-form(ref="form")
                            v-text-field.text-xs-center.password-input.display-1(ref="authcode" :rules="rules" mask="###" v-model="code" outline full-width maxlength="3" type="password") 
                    v-flex(xs6).px-3
                        v-btn(color="success" @click="handleSubmit()" block large) Autorizar
                    v-flex(xs6).px-3
                        v-btn(ref="authbutton" color="warning" @click="showMe = false" block outline large) Cancelar
</template>

<script>
import InputValidation from '@/mixins/InputValidations.js'
export default {
    name: 'auth-modal',
    props: {
        /**
         * @description
         */
        value: {
            type: Boolean,
            default: () => false,
        },
        /**
         * @description
         */
        color: {
            type: String,
            default: () => 'primary',
        },
    },
    data: function() {
        return {
            code: '',
            rules: [
                value => (value.length < 3 ? 'debe ingresar 3 dígitos' : true),
            ],
        }
    },
    computed: {
        showMe: {
            get: function() {
                return this.value
            },
            set: function(boolean) {
                this.$emit('input', boolean)
            },
        },
    },
    methods: {
        handleSubmit: function() {
            if (!this.$refs.form.validate()) return this.handleFocus('authcode')
            this.$emit('submit', this.code)
        },
        handleFocus: function(ref){
            this.$nextTick(() => this.$refs[ref].focus())
        },
        handle: function(e){
            e.preventDefault()
            e.stopPropagation()
            this.handleSubmit()
        }
    },
    watch: {
        /**
         * @description
         */
        value: function(newVal, oldVal){
            if(newVal){
                this.handleFocus('authcode')
            }
        },
    },
    components: {},
    mixins: [InputValidation],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    beforeUpdate: function(){if(!this.value) this.code = ''},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss" scoped>
.password-input {
    overflow: hidden;
    max-width: 120px;
    min-width: 140px;
    max-height: 100px;
}
.input-container {
    display: flex;
    align-items: center;
    flex-direction: column;
}
</style>